import Vue from 'vue';
import store from '@/src/state/store';

Vue.filter('underlyingTranslation', (isin) => {
  return store.getters['underlying/underlyingTranslations'](isin);
});
